var React = require('react');

function TreeAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M318.29 488.85A16 16 0 0 1 304 512h-96a16 16 0 0 1-14.31-23.16L224 440.45V384h64v56.45z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M28 356Q0 328 0 288a93.5 93.5 0 0 1 16-53 92.4 92.4 0 0 1 43-35q-14-24-10.5-49.5a79.43 79.43 0 0 1 20.5-44A81.51 81.51 0 0 1 110.5 82q24.5-6 49.5 5 4-37 31.5-62T256 0q37 0 64.5 25T352 87q25-11 49.5-5a81.51 81.51 0 0 1 41.5 24.5 79.43 79.43 0 0 1 20.5 44Q467 176 454 200h-1a92.4 92.4 0 0 1 43 35 93.5 93.5 0 0 1 16 53q0 40-28 68t-68 28H96q-40 0-68-28z","className":"fa-primary","key":2})]);
}

TreeAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = TreeAlt;

TreeAlt.default = TreeAlt;
